import Select from "react-select";

const customStyles = {
  input: (provided, state) => ({
    ...provided,
    height: "40px",
    outline: state.isFocused ? "transparent" : "transparent",
  }),
  control: (provided, state) => ({
    ...provided,
    outline: "none",
    boxShadow: "none",
    "& input:focus": {
      outline: "none",
      boxShadow: "none",
    },
    borderColor: state.isFocused ? "var(--primary)" : "#d4d4d4",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "var(--primary)" : "transparent",
    color: state.isFocused ? "white" : "var(--primary)",
    "&:hover": {
      backgroundColor: "var(--primary)",
      color: "white",
    },
  }),
  // garante que o menu fique acima de modais (Flowbite, etc.)
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const AutoCompleteInput = ({
  noOptionsMessage = "Nenhum registro encontrado",
  options,
  onChange,
  isLoading,
  label,
  name,
  value,
  disabled = false,
  isMulti = false,
}) => {
  const normalizeValues = (val) => {
    if (Array.isArray(val)) return val.map((v) => String(v));
    if (val === undefined || val === null) return [];
    return [String(val)];
  };

  const values = normalizeValues(value);
  const selectedOption = (() => {
    if (!options) return isMulti ? [] : null;
    if (isMulti) {
      return options.filter((option) =>
        values.includes(String(option.value))
      );
    }
    return options.find((option) => String(option.value) === String(value));
  })();

  return (
    <div className="w-full relative">
      <Select
        noOptionsMessage={() => noOptionsMessage}
        options={options}
        onChange={onChange}
        placeholder=""
        isLoading={isLoading}
        name={name}
        value={selectedOption || null}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        styles={customStyles}
        isDisabled={disabled}
        isMulti={isMulti}
        // --- estes dois são os segredos dentro de modal ---
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
        menuPosition="fixed"
      />

      <label
        htmlFor={name}
        className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-1 z-10 origin-[0] bg-white dark:bg-gray-900 px-2"
      >
        {label}
      </label>
    </div>
  );
};

export default AutoCompleteInput;
